module.exports = __webpack_public_path__ + "img/Carousel2.50bb0f7d.jpg";